import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { store } from './stores/store'
import TripSearchForm from './components/TripSearchForm'
import './i18n'
import './styles/search-trip.scss'
import TripSearchApartmentForm from './components/TripSearchApartmentForm'

let root = document.getElementById('trip-search');

ReactDOM.render(
    <Provider store={store}>
        <TripSearchForm
            customDestination={root.dataset.destination}
            customTransport={root.dataset.transport}
        />
    </Provider>,
    root
)

let rootApartment = document.getElementById('trip-search-apartment');

ReactDOM.render(
    <Provider store={store}>
        <TripSearchApartmentForm
            customDestination={root.dataset.destination}
            customTransport={root.dataset.transport}
            facilities={root.dataset.facilities}
            feeding={root.dataset.feeding}
            operator={root.dataset.operator}
            standard={root.dataset.standard}
            minDays={root.dataset.mindays}
            maxDays={root.dataset.maxdays}
            priceMin={root.dataset.pricemin}
            priceMax={root.dataset.pricemax}
            priceFor={root.dataset.pricefor}
        />
    </Provider>,
    rootApartment
)
